import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {TextField} from 'redux-form-material-ui';
import {Validator} from '../../core/Validator';
import Grid from 'material-ui/Grid';
import LoaderBtn from '../../shared/LoaderBtn/LoaderBtn';

const validate = (values) => Validator.build(values, {
    'email': [Validator.required, Validator.email],
    'password': [Validator.required, Validator.min(8), Validator.password],
    'password_confirm': [Validator.required, Validator.sameAs(values.password)],
});

class SigninForm extends Component {
    render(){
        const {isSigningIn} = this.props;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <Grid container>
                    <Grid item md={12}>
                        <Field
                            name="email"
                            fullWidth={true}
                            component={TextField}
                            label="E-mail"
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Field
                            name="password"
                            fullWidth={true}
                            component={TextField}
                            label="Mot de passe"
                            type="password"
                        />
                    </Grid>
                    <Grid item md={12}>
                        <Field
                            name="password_confirm"
                            fullWidth={true}
                            component={TextField}
                            label="Confirmation du mot de passe"
                            type="password"
                        />
                    </Grid>
                    <Grid item md={12}>
                        <LoaderBtn
                            loading={isSigningIn}
                            type="submit"
                        >
                            Inscription
                        </LoaderBtn>
                    </Grid>
                </Grid>
            </form>

        )
    }
}

export default reduxForm({
    form: 'signinForm',
    validate
})(SigninForm);


// WEBPACK FOOTER //
// ./src/pages/authenticate/SigninForm.js